const UiSimplebarPropsOption = {
  height: { type: [Number, String] },
  spacing: { type: Number, default: 2 },
  trigger: { type: String }
};
const UiSimplebarEmits = {
  scroll: (_ev) => true
};

export { UiSimplebarEmits, UiSimplebarPropsOption };
//# sourceMappingURL=component.mjs.map
